import * as React from "react"

import { USER_ROLE, VISIBILITY_TRACKER_ROUTES } from "@constants"
import AppLayout from "Layout"
import ResourcesPage from "./index"


export const VtResourcesRoutes = {
	path: VISIBILITY_TRACKER_ROUTES.RESOURCES_PATH,
	title: VISIBILITY_TRACKER_ROUTES.RESOURCES_TITLE,
	icon: 'shapes',
	iconWeight: 'light',
	element: <AppLayout />,
	description: 'Master catalogue of unique creative resources (banners, slides, logos) deduped by pHash',
	access: USER_ROLE.ADMIN,
	children: [{
		element: <ResourcesPage />,
		index: true
	}]
}
